<template>
  <div>
    <div class="container mt-5 justify-content-center">
      <div class="card p-3" style="height: 150px">
        <div class="d-flex align-items-center">
          <div class="image">
            <img
              src="@/assets/bank.png"
              class="rounded"
              width="155"
              style="padding: 8px"
            />
          </div>
          <div class="ml-3 w-150" style="padding-top: 5px">
            <h2 class="pl-5 pt-5">Bank Account</h2>
            <v-btn
              style="left: 36px; top: 25px; backgrounf: gainsboro"
              color="grey"
              @click="ClickCreateButton()"
            >
              <v-icon dark> mdi-plus </v-icon> Create
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({}),

  created() {},
  components: {},
  methods: {
    ClickCreateButton() {
      this.$emit('CreatePopup', []);
    },
  },
};
</script>

<style scoped>
body {
  background-color: #b3e5fc;
  border-radius: 10px;
}

.card {
  width: 400px;
  border: none;
  border-radius: 10px;
  background-color: #fff;
}

.stats {
  background: #f2f5f8 !important;
  color: #000 !important;
}

.articles {
  font-size: 10px;
  color: #a1aab9;
}

.number1 {
  font-weight: 500;
}

.followers {
  font-size: 10px;
  color: #a1aab9;
}

.number2 {
  font-weight: 500;
}

.rating {
  font-size: 10px;
  color: #a1aab9;
}

.number3 {
  font-weight: 500;
}
</style>
